import { useState } from 'react'
import { giftCardsApi } from '../api/giftCards'
import Modal from './Modal'
import Boton from './Boton'
import { fmtFechaHora } from '../utils/fecha'
import { colors, text, radius, space } from '../design/tokens'

/**
 * ✉️ Mandar una gift card a un mail (sugerencias #87 y #88, Diego Lloret,
 * 7 oct 2026): cargar o corregir el destinatario DESPUÉS de facturar (ventas
 * corporativas) y reenviarla cuando el mail falló. Activa → sale ya;
 * pendiente → queda guardado y sale con el recibo y la factura. Lo usan el
 * detalle de la NV y el detalle de la gift card.
 */
export default function ModalMandarGiftCard({ card, onClose, onEnviada }) {
  const [email, setEmail] = useState(card.beneficiario_email || '')
  const [nombre, setNombre] = useState(card.beneficiario_nombre || '')
  const [enviando, setEnviando] = useState(false)
  const [error, setError] = useState('')
  const pendiente = card.estado === 'pendiente'

  const mandar = async () => {
    setEnviando(true); setError('')
    try {
      const { data } = await giftCardsApi.mandar(card.id, email.trim(), nombre.trim() || null)
      onEnviada?.(data.message, data.gift_card)
      onClose()
    } catch (e) {
      const errs = e.response?.data?.errors
      setError(errs ? Object.values(errs).flat().join(' ') : (e.response?.data?.message || 'No se pudo mandar.'))
    } finally { setEnviando(false) }
  }

  return (
    <Modal title={`✉️ Mandar ${card.codigo}`} onClose={onClose} maxWidth="460px">
      <div style={st.body}>
        {card.mail_enviado_at && (
          <div style={st.nota}>Ya se mandó el {fmtFechaHora(card.mail_enviado_at)}{card.beneficiario_email ? ` a ${card.beneficiario_email}` : ''}. Se vuelve a mandar al mail de abajo.</div>
        )}
        {pendiente && (
          <div style={st.nota}>La gift card todavía no está activa: el mail queda guardado y sale solo cuando estén el recibo y la factura.</div>
        )}
        <div>
          <label style={st.label}>Mail del destinatario</label>
          <input type="email" style={st.input} value={email} onChange={e => setEmail(e.target.value)} autoFocus />
        </div>
        <div>
          <label style={st.label}>Nombre del destinatario (opcional)</label>
          <input style={st.input} value={nombre} onChange={e => setNombre(e.target.value)} />
        </div>
        {error && <div style={st.error}>{error}</div>}
        <div style={st.acciones}>
          <Boton variante="ghost" onClick={onClose}>Cancelar</Boton>
          <Boton variante="primary" disabled={enviando || !email.trim()} onClick={mandar}>
            {enviando ? 'Mandando…' : pendiente ? 'Guardar' : card.mail_enviado_at ? 'Reenviar' : 'Mandar'}
          </Boton>
        </div>
      </div>
    </Modal>
  )
}

const st = {
  body: { display: 'flex', flexDirection: 'column', gap: space.lg },
  nota: { fontSize: text.sec, color: colors.textSec, background: colors.bgSoft, padding: `${space.md}px ${space.lg}px`, borderRadius: radius.sm },
  label: { display: 'block', fontWeight: 600, fontSize: text.sec, color: colors.text, marginBottom: space.sm },
  input: { width: '100%', padding: `${space.md}px ${space.lg}px`, border: `1px solid ${colors.textPlh}`, borderRadius: radius.sm, fontSize: text.body, boxSizing: 'border-box' },
  error: { background: colors.errBg, color: colors.err, padding: `${space.md}px ${space.lg}px`, borderRadius: radius.sm, fontSize: text.sec },
  acciones: { display: 'flex', justifyContent: 'flex-end', gap: space.md },
}
